import * as React from 'react';
import withIconSvg from '../helpers/withIconSvg';

const Icon: React.FC = (props) => (
	<svg
		height="20"
		width="10"
		viewBox="0 0 10 20"
		{...props}
	>
		<g>
			<path className="st0" d="M9,4C8.8,4,8.7,4,8.6,3.9L5,2.1L1.4,3.9C1,4.1,0.4,3.9,0.1,3.4c-0.2-0.5,0-1.1,0.4-1.3l4-2
				C4.8,0,5.2,0,5.4,0.1l4,2C9.9,2.4,10.1,3,9.9,3.4C9.7,3.8,9.4,4,9,4z"/>
		</g>
		<g>
			<path className="st0" d="M7,7C6.8,7,6.7,7,6.6,6.9L5,6.1L3.4,6.9C3,7.1,2.4,6.9,2.1,6.4C1.9,6,2.1,5.4,2.6,5.1l2-1C4.8,4,5.2,4,5.4,4.1
				l2,1C7.9,5.4,8.1,6,7.9,6.4C7.7,6.8,7.4,7,7,7z"/>
		</g>
		<g>
			<path className="st0" d="M5,11.5c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.2
				c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3c0-0.4,0.2-0.8,0.4-1.1
				C4,8.9,4.1,8.8,4.2,8.8c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.5-0.1,1,0.1,1.3,0.4C6.3,9.2,6.5,9.6,6.5,10
				c0,0.4-0.2,0.8-0.4,1.1C5.8,11.3,5.4,11.5,5,11.5z"/>
		</g>
		<g>
			<path className="st0" d="M5,20c-0.2,0-0.3,0-0.4-0.1l-4-2c-0.5-0.2-0.7-0.8-0.4-1.3c0.2-0.5,0.8-0.7,1.3-0.4L5,17.9l3.6-1.8
				c0.5-0.2,1.1,0,1.3,0.4c0.2,0.5,0,1.1-0.4,1.3l-4,2C5.3,20,5.2,20,5,20z"/>
		</g>
		<g>
			<path className="st0" d="M5,16c-0.2,0-0.3,0-0.4-0.1l-2-1c-0.5-0.2-0.7-0.8-0.4-1.3c0.2-0.5,0.8-0.7,1.3-0.4L5,13.9l1.6-0.8
				c0.5-0.2,1.1,0,1.3,0.4c0.2,0.5,0,1.1-0.4,1.3l-2,1C5.3,16,5.2,16,5,16z"/>
		</g>
	</svg>
);

export default withIconSvg(
	Icon,
	true,
	{
		tags: [
			'host',
			'remote',
		],
	},
);
